import React from 'react';
import {Link} from 'react-router-dom';

import Gravatar from 'react-gravatar';

class KitOrdersList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: props.disabled,

      currShowFull: null
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleShowDetails = this.toggleShowDetails.bind(this);
  }

  handleSelect(order, e) {
    if (this.state.disabled) {
      e.preventDefault();

      return false;
    }

    var checked = e.target.checked;
    if (checked) {
      if (this.props.onSelect) return this.props.onSelect(order, e);
    } else {
      if (this.props.onClear) return this.props.onClear(order, e);
    }
  }

  handleEdit(order, group, e) {
    if (this.state.disabled) {
      e.preventDefault();

      return false;
    }

    return this.props.onEdit(order, group, e);
  }

  handleDelete(order, group, e) {
    if (this.state.disabled) {
      e.preventDefault();

      return false;
    }

    return this.props.onDelete(order, group, e);
  }

  toggleShowDetails(orderId) {
    this.setState((prevState) => {
      prevState.currShowFull = prevState.currShowFull == orderId ? null : orderId;

      return prevState;
    });
  }

  render() {
    const rows = this.props.orders.map((order) => {
      let hasSchool = order.school_id && order.school_id != 'N/D' && order.school_name;

      const labelStyle = {
        color: '#444',
        fontWeight: 'bold'
      };

      const noSchoolStyle = {
        backgroundColor: 'rgb(255, 242, 242)',
        border: '2px solid #fbc5c5',
        padding: '8px'
      };

      const smallerTextStyle = {
        fontSize: '14px'
      }

      return (
        <tr key={order.id} style={hasSchool == false ? noSchoolStyle : {}}>
          {
            this.props.onSelect ? (
              <td className="text-center align-middle">
                <input type="checkbox"className={this.state.disabled ? ' disabled' : ''} checked={this.props.selected !== undefined ? (this.props.selected.indexOf(order.id) != -1 ? true : false) : false} style={{width: '1.2em', height: '1.2em', outline: 'none'}} onClick={(e) => {this.handleSelect(order, e)}} />
              </td>
            ) : ''
          }
          <td className="text-left align-top">
            {
              <span>#{order.id}</span>
            }
          </td>
          <td>
            {
              hasSchool ? (
                <div>
                  <p className="mb-1" style={{color: '#999', fontSize: '14px'}}>
                    <i className={'fa ' + (order.school_parent_school_id ? 'fa-school' : 'fa-university') + ' mr-1'}  style={{fontSize: '13px'}} /> {order.school_type}
                  </p>
                  <h5 className="mt-0 mb-0">
                    <Link to={'/schools/' + order.school_id + '/view/'}>{order.school_name}</Link>
                  </h5>
                  {
                    this.state.currShowFull == order.id ? (
                      <div className="mt-2">
                        <p>
                          {order.school_address}<br />
                          {order.school_postcode} {order.school_city_name} ({order.school_province_iso_code})<br />
                          {order.school_city_id.indexOf('IT') === 0 ? 'Italia' : ''}
                        </p>
                        <p style={smallerTextStyle}>
                          <span style={labelStyle}>Tel.:</span> <a href={'tel:' + order.school_phone}>{order.school_phone}</a><br />
                          <span style={labelStyle}>Fax:</span> {order.school_fax}<br />
                          <span style={labelStyle}>Email:</span> <a href={'mailto:' + order.school_email}>{order.school_email}</a><br />
                          <span style={labelStyle}>PEC:</span> <a href={'mailto:' + order.school_certified_email}>{order.school_certified_email}</a>
                        </p>
                        <p style={smallerTextStyle}>
                          <span style={labelStyle}>Sito web:</span> <a href={order.school_website} target="_BLANK">{order.school_website}</a><br />
                          <span style={labelStyle}>Twitter:</span> <a href={order.school_twitter_url} target="_BLANK">{order.school_twitter_url}</a><br />
                          <span style={labelStyle}>Facebook:</span> <a href={order.school_facebook_url} target="_BLANK">{order.school_facebook_url}</a>
                        </p>
                        <p style={smallerTextStyle}>
                          <span style={labelStyle}>VIP:</span> {order.school_vip ? 'SI' : 'NO'}
                        </p>
                        {
                          order.school_parent_school_id ? (
                            <p>
                              <span style={labelStyle}>I.C.:</span> {order.school_parent_school_name} ({order.school_parent_school_id})
                            </p>
                          ) : ''
                        }
                      </div>
                    ) : (
                      <p className="mb-0">{order.school_city_name} ({order.school_province_iso_code})</p>
                    )
                  }

                  <p className="mt-1 mb-0">
                    <a href="javascript:void(0);" onClick={(e) => this.toggleShowDetails(order.id)} style={{fontSize: '13px', color: '#999'}}>
                      {
                        this.state.currShowFull != order.id ? (
                          <div><i className="fa fa-eye" /> dettagli scuola/insegnante</div>
                        ) : (
                          <div><i className="fa fa-eye-slash" /> nascondi</div>
                        )
                      }
                    </a>
                  </p>
                </div>
              ) : (
                <h5>N/D ({order.school_id ? 'id: ' + order.school_id : 'NO ID'})</h5>
              )
            }
          </td>
          <td>
            {
              order.teacher_email ? (
                <div>
                  <p className="mb-1" style={{color: '#999', fontSize: '14px'}}>
                    <i className="fa fa-chalkboard-order.teacher_ mr-1" style={{fontSize: '13px'}} />
                    INS. {order.teacher_subject.toUpperCase()}
                  </p>
                  <h5 className="mt-0 mb-0">
                    <Link to={'/teachers/' + order.teacher_key + '/view/'}>{order.teacher_first_name} {order.teacher_last_name}</Link>
                  </h5>
                  {
                    this.state.currShowFull == order.id ? (
                      <div className="mt-2">
                        <p style={smallerTextStyle}>
                          <span style={labelStyle}>Tel.:</span> <a href={'tel:' + order.teacher_phone}>{order.teacher_phone}</a><br />
                          <span style={labelStyle}>Email:</span> <a href={'mailto:' + order.teacher_email}>{order.teacher_email}</a>
                        </p>
                        <p style={smallerTextStyle}>
                          <span style={labelStyle}>Materia:</span> {order.teacher_subject}
                        </p>
                      </div>
                    ) : ''
                  }
                  <p className="mt-1 mb-0">
                    <a href="javascript:void(0);" onClick={(e) => this.toggleShowDetails(order.id)} style={{fontSize: '13px', color: '#999'}}>
                      {
                        this.state.currShowFull != order.id ? (
                          <div><i className="fa fa-eye" /> dettagli scuola/insegnante</div>
                        ) : (
                          <div><i className="fa fa-eye-slash" /> nascondi</div>
                        )
                      }
                    </a>
                  </p>
                </div>
              ) : (
                <h5>N/D</h5>
              )
            }
          </td>
          <td>
            {
              order.items.map((item, i) => {
                return (
                  <div className="mb-2">
                    {i != 0 ? <hr /> : ''}

                    #{item.id} · {item.schoolclass_type} {item.schoolclass_sec} ({item.schoolclass_num_students} alunni)<br />
                    {
                      <span style={smallerTextStyle}>
                        <i className={'fa ' + (item.shippable ? 'fa-check' : 'fa-ban')} /> {item.shippable ? 'in target' : 'extra target'} · {item.status} · {item.shipped_on ? item.shipped_on.split(' ')[0] : 'NO'}
                      </span>
                    }
                  </div>
                );
              })
            }
          </td>
          {
            !this.props.noedit ? (
                <td className="text-center align-middle">
                  <Link to={'/kit-orders/' + order.items[0].kit_id + '/orders/' + order.id + '/edit/'} className={'btn btn-secondary' + (this.state.disabled ? ' disabled' : '')}><i className="fa fa-pencil" /></Link>
                </td>
            ) : ''
          }
          {
            this.props.onDelete ? (
              <td className="text-center align-middle">
                <a href="javascript:void(0);"className={'btn btn-danger' + (this.state.disabled ? ' disabled' : '')} onClick={(e) => {this.handleDelete(order, e)}}><i className="fa fa-times" /></a>
              </td>
            ) : ''
          }
        </tr>
      );
    });

    var colW = (100 - 5 - (this.props.onSelect ? 5 : 0) - (this.props.onEdit ? 5 : 0) - (this.props.onDelete ? 5 : 0)) / 3;

    return (
      <table border="1" width="100%" className="table">
        <thead>
          <tr>
            {this.props.onSelect ? <th width="5%" className="text-left align-top"></th>  : ""}
            <th width="5%" className="text-left align-top">ID</th>
            <th width={colW * 1.25 + '%'} className="text-left align-top">Scuola</th>
            <th width={colW * 0.75 + '%'} className="text-left align-top">Insegnante</th>
            <th width={colW + '%'} className="text-left align-top">Richieste</th>
            {!this.props.noedit ? <th width="5%" className="text-left align-top"></th>  : ""}
            {this.props.onDelete ? <th width="5%" className="text-left align-top"></th>  : ""}
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }
}

export default KitOrdersList;



// WEBPACK FOOTER //
// ./src/components/kit-orders/details/KitOrdersList.js